
  import { mapGetters } from 'vuex';

  export default {
    props: {
      count: { type: Number, required: true },
      direction: { type: Number, default: 1 },
      sort: { type: String, default: null },
      sortable: { type: Boolean, default: true },
      working: { type: Boolean, default: false }
    },
    data: () => ({
      theProduct: ''
    }),
    computed: {
      ...mapGetters('utils', { pageMeta: 'getMeta' })
    }
  };
